/**
 * Formats a number to a price in GBP with a given number of fractional digits.
 * @param {number | `${number}`} num - Number
 * @param {number} digits - Fractional digits
 * @returns {string} Price
 */
export const formatPrice = (num, digits = 0) => {
	let _num = parseFloat(num);
	// estimated:parseFloat((appOneIncome + appTwoIncome) * 4.5.toLocaleString('en', { useGrouping: true }))),

	if (isNaN(_num)) {
		return `${num}`;
	}

	_num = Math.round(_num);
	const formatter = new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: digits
	});

	return formatter.format(_num);
};

/**
 * Formats a number to a percentage with a given number of fractional digits.
 * @param {number | `${number}`} num - Number
 * @param {number} digits
 * @returns {string} Percentage
 */
export const formatPercentage = (num, digits = 0) => {
	const _num = parseFloat(num);

	if (isNaN(_num)) {
		return `${num}`;
	}

	const formatter = new Intl.NumberFormat('en-GB', {
		style: 'percent',
		currency: 'GBP',
		maximumFractionDigits: digits
	});

	return formatter.format(_num);
};
